import { handleImportRoutes, sortRoutes } from '@/router/helpers';

// 只导入public目录下的路由（静态官网路由）
const modules = import.meta.glob('./public/*.jsx', { eager: true });

const rawRoutes = sortRoutes(handleImportRoutes(modules)).flat();

export { rawRoutes };
